var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIconV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.33398C4.32536 1.33398 1.33203 4.32732 1.33203 8.00065C1.33203 11.674 4.32536 14.6673 7.9987 14.6673C11.672 14.6673 14.6654 11.674 14.6654 8.00065C14.6654 4.32732 11.672 1.33398 7.9987 1.33398ZM10.8987 10.3807C10.8054 10.5407 10.6387 10.6273 10.4654 10.6273C10.3787 10.6273 10.292 10.6073 10.212 10.554L8.14536 9.32065C7.63203 9.01398 7.25203 8.34065 7.25203 7.74732V5.01398C7.25203 4.74065 7.4787 4.51398 7.75203 4.51398C8.02536 4.51398 8.25203 4.74065 8.25203 5.01398V7.74732C8.25203 7.98732 8.45203 8.34065 8.6587 8.46065L10.7254 9.69398C10.9654 9.83398 11.0454 10.1407 10.8987 10.3807Z",
    fill: "#00A79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconV2);
export default __webpack_public_path__ + "static/media/clock-icon-v2.2a2f70e56dab5914a2a73c29b97bc244.svg";
export { ForwardRef as ReactComponent };